import axios from "../../../axios";
import { getUserAccessToken } from "../user";
  
export const pausePayment = async (payload) => {
    try {
        let token = await getUserAccessToken();
        let headers = {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Frame-Options": "sameorigin",
            "strict-transport-security": "max-age=31536000; includeSubDomains",
            "X-XSS-Protection": "1; mode=block",
            "x-content-type-options": "nosniff",
            "X-Download-Options": "noopen",
            "Content-Security-Policy": "policy",
          },
        };
        let {status} = await axios.post(
          `${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/tf_payments/pause_subscription`,payload,
          headers
        );
        return status;
    } catch (e) {
        console.log("error while getting workers", e)
    }
};
